import cn from './lang/zh-CN';
import en from './lang/en-US';
export default {
    'zh-CN': cn,
    'en-US': en
};


// WEBPACK FOOTER //
// ./src/locale/locale.js